export { default as ScrollableFade } from './ScrollableFade.vue';
export { FadeDirection, SCROLLABLE_FADE_CONFIG } from './config';
